import * as Config from '../../config'
import axios from 'axios'

const state = {
    notifications: null,
}

const actions = {
    getNotifications({ commit }) {

        var header = {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            }
        }

        return axios.get(Config.apiPath + '/api/v2/notifications/unread', header).then((response) => {

            if(Config.debugMode) console.log(response.data)
            
            commit('setNotifications', response.data)

            return Promise.resolve(response.data)

        }).catch(error => {
            return 401;
        });

    },

    readNotifications({commit}) {
        var header = {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            }
        }

        return axios.post(Config.apiPath + '/api/v2/notifications/read', null, header).then((response) => {

            if(Config.debugMode) console.log(response.data)
            
            commit('setNotifications', response.data)

            return Promise.resolve(response.data)
            
        }).catch(error => {
            return 401;
        });

    },

    readNotification({commit}, notification) {
        
        console.log(notification)

        var header = {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            }
        }

        var data = {
            notification: notification,
        }

        return axios.post(Config.apiPath + '/api/v2/notifications/read/' + notification.id, data, header).then((response) => {

            if(Config.debugMode) console.log(response.data)
            
            commit('setNotifications', response.data)

            return Promise.resolve(response.data)
            
        }).catch(error => {
            return 401;
        });

    }

}

const mutations = {
    updateNotifications(state, data) {
        // edit this to work correctly
        state.notifications = data;
    },
    setNotifications(state, data) {
        state.notifications = data;
    },
}

const getters = {
    hasNotifications: state => {
        if(state.notifications == null) return false
        if(state.notifications.length > 0) return true
        return false
    },

    notifications: state => {
        return state.notifications
    },

    notificationsCount: state => {
        if(state.notifications == null) {
            return 0
        }
        return state.notifications.length
    }
}

export default {
    state,
    mutations,
    getters,
    actions
}